/* Copyright (C) 2021 ev-i Informationstechnologie GmbH */

export class PlotOrderTemplateSearchModel {
    projectId : number;
    plotOrderTemplateId : number;
    templateResolver : string;
    withValidReceivers : boolean;
}
